import {Observable} from 'rxjs';
import {FilterCriterion} from '../../models/filters/filter-criterion';

export type AutocompleteValueGetter = (value: any) => any;
export type AutocompleteDisplayValueGetter = (value: any) => string;

export type AutocompleteSearchType<R> = string | AutocompleteProvider<R> | AutocompleteProviderConfig<R>;

export interface AutocompleteConfig {

    /**
     * Set resulting value to the input text if no variant is selected.
     */
    freeTyping?: boolean;

    /**
     * Enum or string in case of dedicated autocomplete API usage (deprecated) or service instance.
     */
    type?: AutocompleteSearchType<any>;

    /**
     * Used to convert values from the autocomplete service to the model convenient value.
     */
    value?: AutocompleteValueGetter;

    /**
     * Used to convert model convenient values to display values.
     */
    displayValue?: AutocompleteDisplayValueGetter;

    selectAllOnFocus?: boolean;

    /**
     * When possible set only variant
     */
    disallowEmptySelect?: boolean;

    /**
     * When possible set variant or null. Incompatible with disallowEmptySelect.
     */
    allowVariantOrNull?: boolean;

    /**
     *  Allows to open suggestion list when input is empty
     *  (Ctrl+Space or when user deletes all symbols while the list is open).
     */
    allowVariantsForEmptyTerm?: boolean;
}

export interface AutocompleteProviderConfig<T> {
    provider: AutocompleteProvider<T>;
    termFieldNames?: string[];
    sortFieldName?: string;
    filters?: FilterCriterion[];
}

export function getAutocompleteValue(variant: any, config: AutocompleteConfig): any {
    const getter: AutocompleteValueGetter = config.value;

    return getter ? getter(variant) : variant;
}

export function getAutocompleteDisplayValue(variant: any, config: AutocompleteConfig): string {
    const getter: AutocompleteDisplayValueGetter = config.displayValue;

    return variant
        ? getter ? getter(variant) : variant
        : '';
}

export interface AutocompleteProvider<T> {
    autocomplete(term: string, config?: AutocompleteProviderConfig<T>): Observable<T[]>;
}
